// Generated by scripts/optimize-images.py. Edit the originals, then regenerate.
// Keep image order and duplicate gallery entries consistent with the original site.
import image0_480 from "./images/responsive/aboutUs2-480.webp";
import image0_960 from "./images/responsive/aboutUs2-960.webp";
import image0_1500 from "./images/responsive/aboutUs2-1500.webp";
import image1_480 from "./images/responsive/cardSection-480.webp";
import image1_960 from "./images/responsive/cardSection-960.webp";
import image1_1001 from "./images/responsive/cardSection-1001.webp";
import image2_480 from "./images/responsive/carteBodeguita-480.webp";
import image2_960 from "./images/responsive/carteBodeguita-960.webp";
import image2_1500 from "./images/responsive/carteBodeguita-1500.webp";
import image3_480 from "./images/responsive/carteRestaurant-480.webp";
import image3_960 from "./images/responsive/carteRestaurant-960.webp";
import image3_1001 from "./images/responsive/carteRestaurant-1001.webp";
import image4_480 from "./images/responsive/couverture-480.webp";
import image4_960 from "./images/responsive/couverture-960.webp";
import image4_1500 from "./images/responsive/couverture-1500.webp";
import image5_480 from "./images/responsive/couvertureCardMenu-480.webp";
import image5_960 from "./images/responsive/couvertureCardMenu-960.webp";
import image5_1500 from "./images/responsive/couvertureCardMenu-1500.webp";
import image6_480 from "./images/responsive/couvertureImageGallery-480.webp";
import image6_960 from "./images/responsive/couvertureImageGallery-960.webp";
import image6_1500 from "./images/responsive/couvertureImageGallery-1500.webp";
import image7_480 from "./images/responsive/diapo01-480.webp";
import image7_960 from "./images/responsive/diapo01-960.webp";
import image7_1500 from "./images/responsive/diapo01-1500.webp";
import image8_480 from "./images/responsive/diapo02-480.webp";
import image8_960 from "./images/responsive/diapo02-960.webp";
import image8_1001 from "./images/responsive/diapo02-1001.webp";
import image9_480 from "./images/responsive/diapo03-480.webp";
import image9_960 from "./images/responsive/diapo03-960.webp";
import image9_1500 from "./images/responsive/diapo03-1500.webp";
import image10_480 from "./images/responsive/diapo04-480.webp";
import image10_960 from "./images/responsive/diapo04-960.webp";
import image10_1001 from "./images/responsive/diapo04-1001.webp";
import image11_480 from "./images/responsive/diapo05-480.webp";
import image11_960 from "./images/responsive/diapo05-960.webp";
import image11_1001 from "./images/responsive/diapo05-1001.webp";
import image12_480 from "./images/responsive/diapo06-480.webp";
import image12_960 from "./images/responsive/diapo06-960.webp";
import image12_1500 from "./images/responsive/diapo06-1500.webp";
import image13_480 from "./images/responsive/diapo07-480.webp";
import image13_960 from "./images/responsive/diapo07-960.webp";
import image13_1001 from "./images/responsive/diapo07-1001.webp";
import image14_480 from "./images/responsive/diapo08-480.webp";
import image14_960 from "./images/responsive/diapo08-960.webp";
import image14_1500 from "./images/responsive/diapo08-1500.webp";
import image15_480 from "./images/responsive/diapo09-480.webp";
import image15_960 from "./images/responsive/diapo09-960.webp";
import image15_1500 from "./images/responsive/diapo09-1500.webp";
import image16_480 from "./images/responsive/diapo10-480.webp";
import image16_960 from "./images/responsive/diapo10-960.webp";
import image16_1500 from "./images/responsive/diapo10-1500.webp";
import image17_480 from "./images/responsive/galerie-01-rue-enseigne-480.webp";
import image17_960 from "./images/responsive/galerie-01-rue-enseigne-960.webp";
import image17_1500 from "./images/responsive/galerie-01-rue-enseigne-1500.webp";
import image18_480 from "./images/responsive/galerie-02-enseigne-bouddoir-480.webp";
import image18_960 from "./images/responsive/galerie-02-enseigne-bouddoir-960.webp";
import image18_1001 from "./images/responsive/galerie-02-enseigne-bouddoir-1001.webp";
import image19_480 from "./images/responsive/galerie-03-terrasse-fontaine-480.webp";
import image19_960 from "./images/responsive/galerie-03-terrasse-fontaine-960.webp";
import image19_1001 from "./images/responsive/galerie-03-terrasse-fontaine-1001.webp";
import image20_480 from "./images/responsive/galerie-04-terrasse-jour-480.webp";
import image20_960 from "./images/responsive/galerie-04-terrasse-jour-960.webp";
import image20_1001 from "./images/responsive/galerie-04-terrasse-jour-1001.webp";
import image21_480 from "./images/responsive/galerie-05-terrasse-soir-480.webp";
import image21_960 from "./images/responsive/galerie-05-terrasse-soir-960.webp";
import image21_1500 from "./images/responsive/galerie-05-terrasse-soir-1500.webp";
import image22_480 from "./images/responsive/galerie-06-terrasse-lanternes-480.webp";
import image22_960 from "./images/responsive/galerie-06-terrasse-lanternes-960.webp";
import image22_1001 from "./images/responsive/galerie-06-terrasse-lanternes-1001.webp";
import image23_480 from "./images/responsive/galerie-07-salle-480.webp";
import image23_960 from "./images/responsive/galerie-07-salle-960.webp";
import image23_1001 from "./images/responsive/galerie-07-salle-1001.webp";
import image24_480 from "./images/responsive/galerie-08-bar-480.webp";
import image24_960 from "./images/responsive/galerie-08-bar-960.webp";
import image24_1001 from "./images/responsive/galerie-08-bar-1001.webp";
import image25_480 from "./images/responsive/galerie-09-cave-a-vins-480.webp";
import image25_960 from "./images/responsive/galerie-09-cave-a-vins-960.webp";
import image25_1001 from "./images/responsive/galerie-09-cave-a-vins-1001.webp";
import image26_480 from "./images/responsive/galerie-10-fresque-480.webp";
import image26_960 from "./images/responsive/galerie-10-fresque-960.webp";
import image26_1500 from "./images/responsive/galerie-10-fresque-1500.webp";
import image27_480 from "./images/responsive/galerie-11-detail-mural-480.webp";
import image27_960 from "./images/responsive/galerie-11-detail-mural-960.webp";
import image27_1500 from "./images/responsive/galerie-11-detail-mural-1500.webp";
import image28_480 from "./images/responsive/galerie-12-suspension-480.webp";
import image28_960 from "./images/responsive/galerie-12-suspension-960.webp";
import image28_1500 from "./images/responsive/galerie-12-suspension-1500.webp";
import image29_480 from "./images/responsive/galerie-13-brunch-jus-480.webp";
import image29_960 from "./images/responsive/galerie-13-brunch-jus-960.webp";
import image29_1001 from "./images/responsive/galerie-13-brunch-jus-1001.webp";
import image30_480 from "./images/responsive/galerie-14-brunch-table-480.webp";
import image30_960 from "./images/responsive/galerie-14-brunch-table-960.webp";
import image30_1500 from "./images/responsive/galerie-14-brunch-table-1500.webp";
import image31_480 from "./images/responsive/galerie-15-cafe-latte-480.webp";
import image31_960 from "./images/responsive/galerie-15-cafe-latte-960.webp";
import image31_1001 from "./images/responsive/galerie-15-cafe-latte-1001.webp";
import image32_480 from "./images/responsive/galerie-16-expresso-480.webp";
import image32_960 from "./images/responsive/galerie-16-expresso-960.webp";
import image32_1500 from "./images/responsive/galerie-16-expresso-1500.webp";
import image33_480 from "./images/responsive/galerie-17-cafe-terrasse-480.webp";
import image33_960 from "./images/responsive/galerie-17-cafe-terrasse-960.webp";
import image33_1001 from "./images/responsive/galerie-17-cafe-terrasse-1001.webp";
import image34_480 from "./images/responsive/galerie-18-fruits-cocktails-480.webp";
import image34_960 from "./images/responsive/galerie-18-fruits-cocktails-960.webp";
import image34_1500 from "./images/responsive/galerie-18-fruits-cocktails-1500.webp";
import image35_480 from "./images/responsive/galerie-19-mojitos-480.webp";
import image35_960 from "./images/responsive/galerie-19-mojitos-960.webp";
import image35_1001 from "./images/responsive/galerie-19-mojitos-1001.webp";
import image36_480 from "./images/responsive/galerie-20-gin-fruits-rouges-480.webp";
import image36_960 from "./images/responsive/galerie-20-gin-fruits-rouges-960.webp";
import image36_1001 from "./images/responsive/galerie-20-gin-fruits-rouges-1001.webp";
import image37_480 from "./images/responsive/galerie-21-cocktail-citron-480.webp";
import image37_960 from "./images/responsive/galerie-21-cocktail-citron-960.webp";
import image37_1001 from "./images/responsive/galerie-21-cocktail-citron-1001.webp";
import image38_480 from "./images/responsive/galerie-22-preparation-480.webp";
import image38_960 from "./images/responsive/galerie-22-preparation-960.webp";
import image38_1001 from "./images/responsive/galerie-22-preparation-1001.webp";
import image39_480 from "./images/responsive/galerie-23-cocktail-rouge-480.webp";
import image39_960 from "./images/responsive/galerie-23-cocktail-rouge-960.webp";
import image39_1001 from "./images/responsive/galerie-23-cocktail-rouge-1001.webp";
import image40_480 from "./images/responsive/galerie-24-cocktail-ananas-480.webp";
import image40_960 from "./images/responsive/galerie-24-cocktail-ananas-960.webp";
import image40_1001 from "./images/responsive/galerie-24-cocktail-ananas-1001.webp";
import image41_480 from "./images/responsive/galerie-25-cocktail-rose-480.webp";
import image41_960 from "./images/responsive/galerie-25-cocktail-rose-960.webp";
import image41_1001 from "./images/responsive/galerie-25-cocktail-rose-1001.webp";
import image42_480 from "./images/responsive/galerie-26-cocktail-flambe-480.webp";
import image42_960 from "./images/responsive/galerie-26-cocktail-flambe-960.webp";
import image42_1001 from "./images/responsive/galerie-26-cocktail-flambe-1001.webp";
import image43_480 from "./images/responsive/galerie-27-bieres-480.webp";
import image43_960 from "./images/responsive/galerie-27-bieres-960.webp";
import image43_1001 from "./images/responsive/galerie-27-bieres-1001.webp";
import image44_480 from "./images/responsive/galerie-28-pates-burrata-480.webp";
import image44_960 from "./images/responsive/galerie-28-pates-burrata-960.webp";
import image44_1001 from "./images/responsive/galerie-28-pates-burrata-1001.webp";
import image45_480 from "./images/responsive/galerie-29-tartare-frites-480.webp";
import image45_960 from "./images/responsive/galerie-29-tartare-frites-960.webp";
import image45_1001 from "./images/responsive/galerie-29-tartare-frites-1001.webp";
import image46_480 from "./images/responsive/galerie-30-tartine-480.webp";
import image46_960 from "./images/responsive/galerie-30-tartine-960.webp";
import image46_1001 from "./images/responsive/galerie-30-tartine-1001.webp";
import image47_480 from "./images/responsive/galerie-31-tartine-burrata-480.webp";
import image47_960 from "./images/responsive/galerie-31-tartine-burrata-960.webp";
import image47_1500 from "./images/responsive/galerie-31-tartine-burrata-1500.webp";
import image48_480 from "./images/responsive/galerie-32-entrecote-frites-480.webp";
import image48_960 from "./images/responsive/galerie-32-entrecote-frites-960.webp";
import image48_1001 from "./images/responsive/galerie-32-entrecote-frites-1001.webp";
import image49_480 from "./images/responsive/galerie-33-travers-480.webp";
import image49_960 from "./images/responsive/galerie-33-travers-960.webp";
import image49_1001 from "./images/responsive/galerie-33-travers-1001.webp";
import image50_480 from "./images/responsive/galerie-34-service-plats-480.webp";
import image50_960 from "./images/responsive/galerie-34-service-plats-960.webp";
import image50_1500 from "./images/responsive/galerie-34-service-plats-1500.webp";
import image51_480 from "./images/responsive/galerie-35-ceviche-frites-480.webp";
import image51_960 from "./images/responsive/galerie-35-ceviche-frites-960.webp";
import image51_1001 from "./images/responsive/galerie-35-ceviche-frites-1001.webp";
import image52_480 from "./images/responsive/galerie-36-nachos-480.webp";
import image52_960 from "./images/responsive/galerie-36-nachos-960.webp";
import image52_1500 from "./images/responsive/galerie-36-nachos-1500.webp";
import image53_480 from "./images/responsive/galerie-37-empanada-480.webp";
import image53_960 from "./images/responsive/galerie-37-empanada-960.webp";
import image53_1500 from "./images/responsive/galerie-37-empanada-1500.webp";
import image54_480 from "./images/responsive/galerie-38-salade-poulet-480.webp";
import image54_960 from "./images/responsive/galerie-38-salade-poulet-960.webp";
import image54_1001 from "./images/responsive/galerie-38-salade-poulet-1001.webp";
import image55_480 from "./images/responsive/galerie-39-tapas-planche-480.webp";
import image55_960 from "./images/responsive/galerie-39-tapas-planche-960.webp";
import image55_1500 from "./images/responsive/galerie-39-tapas-planche-1500.webp";
import image56_480 from "./images/responsive/galerie-40-salade-nicoise-480.webp";
import image56_960 from "./images/responsive/galerie-40-salade-nicoise-960.webp";
import image56_1001 from "./images/responsive/galerie-40-salade-nicoise-1001.webp";
import image57_480 from "./images/responsive/galerie-41-poulpe-assiette-480.webp";
import image57_960 from "./images/responsive/galerie-41-poulpe-assiette-960.webp";
import image57_1001 from "./images/responsive/galerie-41-poulpe-assiette-1001.webp";
import image58_480 from "./images/responsive/galerie-42-tacos-480.webp";
import image58_960 from "./images/responsive/galerie-42-tacos-960.webp";
import image58_1001 from "./images/responsive/galerie-42-tacos-1001.webp";
import image59_480 from "./images/responsive/galerie-43-entrecote-dressee-480.webp";
import image59_960 from "./images/responsive/galerie-43-entrecote-dressee-960.webp";
import image59_1001 from "./images/responsive/galerie-43-entrecote-dressee-1001.webp";
import image60_480 from "./images/responsive/galerie-44-poulpe-grille-480.webp";
import image60_960 from "./images/responsive/galerie-44-poulpe-grille-960.webp";
import image60_1001 from "./images/responsive/galerie-44-poulpe-grille-1001.webp";
import image61_480 from "./images/responsive/galerie-45-four-a-bois-480.webp";
import image61_960 from "./images/responsive/galerie-45-four-a-bois-960.webp";
import image61_1500 from "./images/responsive/galerie-45-four-a-bois-1500.webp";
import image62_480 from "./images/responsive/galerie-46-pizzaiolo-480.webp";
import image62_960 from "./images/responsive/galerie-46-pizzaiolo-960.webp";
import image62_1001 from "./images/responsive/galerie-46-pizzaiolo-1001.webp";
import image63_480 from "./images/responsive/galerie-47-pizza-flammes-480.webp";
import image63_960 from "./images/responsive/galerie-47-pizza-flammes-960.webp";
import image63_1500 from "./images/responsive/galerie-47-pizza-flammes-1500.webp";
import image64_480 from "./images/responsive/galerie-48-viande-grill-480.webp";
import image64_960 from "./images/responsive/galerie-48-viande-grill-960.webp";
import image64_1001 from "./images/responsive/galerie-48-viande-grill-1001.webp";
import image65_480 from "./images/responsive/galerie-49-poulpe-grill-480.webp";
import image65_960 from "./images/responsive/galerie-49-poulpe-grill-960.webp";
import image65_1001 from "./images/responsive/galerie-49-poulpe-grill-1001.webp";
import image66_480 from "./images/responsive/galerie-50-dessert-fraises-480.webp";
import image66_960 from "./images/responsive/galerie-50-dessert-fraises-960.webp";
import image66_1001 from "./images/responsive/galerie-50-dessert-fraises-1001.webp";
import image67_480 from "./images/responsive/galerie-51-fondant-480.webp";
import image67_960 from "./images/responsive/galerie-51-fondant-960.webp";
import image67_1085 from "./images/responsive/galerie-51-fondant-1085.webp";
import image68_480 from "./images/responsive/galerie-52-tiramisu-480.webp";
import image68_960 from "./images/responsive/galerie-52-tiramisu-960.webp";
import image68_1001 from "./images/responsive/galerie-52-tiramisu-1001.webp";
import image69_480 from "./images/responsive/galerie-53-equipe-480.webp";
import image69_960 from "./images/responsive/galerie-53-equipe-960.webp";
import image69_1500 from "./images/responsive/galerie-53-equipe-1500.webp";
import image70_480 from "./images/responsive/galerie-54-chef-cuisine-480.webp";
import image70_960 from "./images/responsive/galerie-54-chef-cuisine-960.webp";
import image70_1001 from "./images/responsive/galerie-54-chef-cuisine-1001.webp";
import image71_480 from "./images/responsive/galerie-55-chef-portrait-480.webp";
import image71_960 from "./images/responsive/galerie-55-chef-portrait-960.webp";
import image71_1500 from "./images/responsive/galerie-55-chef-portrait-1500.webp";
import image72_480 from "./images/responsive/infoPractice-480.webp";
import image72_960 from "./images/responsive/infoPractice-960.webp";
import image72_1500 from "./images/responsive/infoPractice-1500.webp";
import image73_480 from "./images/responsive/presentation-480.webp";
import image73_960 from "./images/responsive/presentation-960.webp";
import image73_1500 from "./images/responsive/presentation-1500.webp";

export interface ResponsiveImageAsset {
    name: string;
    src: string;
    srcSet: string;
    width: number;
    height: number;
}

export const imageAssets = {
    "aboutUs2": {
        name: "aboutUs2",
        src: image0_1500,
        srcSet: `${image0_480} 480w, ${image0_960} 960w, ${image0_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "cardSection": {
        name: "cardSection",
        src: image1_1001,
        srcSet: `${image1_480} 480w, ${image1_960} 960w, ${image1_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "carteBodeguita": {
        name: "carteBodeguita",
        src: image2_1500,
        srcSet: `${image2_480} 480w, ${image2_960} 960w, ${image2_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "carteRestaurant": {
        name: "carteRestaurant",
        src: image3_1001,
        srcSet: `${image3_480} 480w, ${image3_960} 960w, ${image3_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "couverture": {
        name: "couverture",
        src: image4_1500,
        srcSet: `${image4_480} 480w, ${image4_960} 960w, ${image4_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "couvertureCardMenu": {
        name: "couvertureCardMenu",
        src: image5_1500,
        srcSet: `${image5_480} 480w, ${image5_960} 960w, ${image5_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "couvertureImageGallery": {
        name: "couvertureImageGallery",
        src: image6_1500,
        srcSet: `${image6_480} 480w, ${image6_960} 960w, ${image6_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo01": {
        name: "diapo01",
        src: image7_1500,
        srcSet: `${image7_480} 480w, ${image7_960} 960w, ${image7_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo02": {
        name: "diapo02",
        src: image8_1001,
        srcSet: `${image8_480} 480w, ${image8_960} 960w, ${image8_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "diapo03": {
        name: "diapo03",
        src: image9_1500,
        srcSet: `${image9_480} 480w, ${image9_960} 960w, ${image9_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo04": {
        name: "diapo04",
        src: image10_1001,
        srcSet: `${image10_480} 480w, ${image10_960} 960w, ${image10_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "diapo05": {
        name: "diapo05",
        src: image11_1001,
        srcSet: `${image11_480} 480w, ${image11_960} 960w, ${image11_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "diapo06": {
        name: "diapo06",
        src: image12_1500,
        srcSet: `${image12_480} 480w, ${image12_960} 960w, ${image12_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo07": {
        name: "diapo07",
        src: image13_1001,
        srcSet: `${image13_480} 480w, ${image13_960} 960w, ${image13_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "diapo08": {
        name: "diapo08",
        src: image14_1500,
        srcSet: `${image14_480} 480w, ${image14_960} 960w, ${image14_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo09": {
        name: "diapo09",
        src: image15_1500,
        srcSet: `${image15_480} 480w, ${image15_960} 960w, ${image15_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "diapo10": {
        name: "diapo10",
        src: image16_1500,
        srcSet: `${image16_480} 480w, ${image16_960} 960w, ${image16_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-01-rue-enseigne": {
        name: "galerie-01-rue-enseigne",
        src: image17_1500,
        srcSet: `${image17_480} 480w, ${image17_960} 960w, ${image17_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-02-enseigne-bouddoir": {
        name: "galerie-02-enseigne-bouddoir",
        src: image18_1001,
        srcSet: `${image18_480} 480w, ${image18_960} 960w, ${image18_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-03-terrasse-fontaine": {
        name: "galerie-03-terrasse-fontaine",
        src: image19_1001,
        srcSet: `${image19_480} 480w, ${image19_960} 960w, ${image19_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-04-terrasse-jour": {
        name: "galerie-04-terrasse-jour",
        src: image20_1001,
        srcSet: `${image20_480} 480w, ${image20_960} 960w, ${image20_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-05-terrasse-soir": {
        name: "galerie-05-terrasse-soir",
        src: image21_1500,
        srcSet: `${image21_480} 480w, ${image21_960} 960w, ${image21_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-06-terrasse-lanternes": {
        name: "galerie-06-terrasse-lanternes",
        src: image22_1001,
        srcSet: `${image22_480} 480w, ${image22_960} 960w, ${image22_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-07-salle": {
        name: "galerie-07-salle",
        src: image23_1001,
        srcSet: `${image23_480} 480w, ${image23_960} 960w, ${image23_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-08-bar": {
        name: "galerie-08-bar",
        src: image24_1001,
        srcSet: `${image24_480} 480w, ${image24_960} 960w, ${image24_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-09-cave-a-vins": {
        name: "galerie-09-cave-a-vins",
        src: image25_1001,
        srcSet: `${image25_480} 480w, ${image25_960} 960w, ${image25_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-10-fresque": {
        name: "galerie-10-fresque",
        src: image26_1500,
        srcSet: `${image26_480} 480w, ${image26_960} 960w, ${image26_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-11-detail-mural": {
        name: "galerie-11-detail-mural",
        src: image27_1500,
        srcSet: `${image27_480} 480w, ${image27_960} 960w, ${image27_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-12-suspension": {
        name: "galerie-12-suspension",
        src: image28_1500,
        srcSet: `${image28_480} 480w, ${image28_960} 960w, ${image28_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-13-brunch-jus": {
        name: "galerie-13-brunch-jus",
        src: image29_1001,
        srcSet: `${image29_480} 480w, ${image29_960} 960w, ${image29_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-14-brunch-table": {
        name: "galerie-14-brunch-table",
        src: image30_1500,
        srcSet: `${image30_480} 480w, ${image30_960} 960w, ${image30_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-15-cafe-latte": {
        name: "galerie-15-cafe-latte",
        src: image31_1001,
        srcSet: `${image31_480} 480w, ${image31_960} 960w, ${image31_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-16-expresso": {
        name: "galerie-16-expresso",
        src: image32_1500,
        srcSet: `${image32_480} 480w, ${image32_960} 960w, ${image32_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-17-cafe-terrasse": {
        name: "galerie-17-cafe-terrasse",
        src: image33_1001,
        srcSet: `${image33_480} 480w, ${image33_960} 960w, ${image33_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-18-fruits-cocktails": {
        name: "galerie-18-fruits-cocktails",
        src: image34_1500,
        srcSet: `${image34_480} 480w, ${image34_960} 960w, ${image34_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-19-mojitos": {
        name: "galerie-19-mojitos",
        src: image35_1001,
        srcSet: `${image35_480} 480w, ${image35_960} 960w, ${image35_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-20-gin-fruits-rouges": {
        name: "galerie-20-gin-fruits-rouges",
        src: image36_1001,
        srcSet: `${image36_480} 480w, ${image36_960} 960w, ${image36_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-21-cocktail-citron": {
        name: "galerie-21-cocktail-citron",
        src: image37_1001,
        srcSet: `${image37_480} 480w, ${image37_960} 960w, ${image37_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-22-preparation": {
        name: "galerie-22-preparation",
        src: image38_1001,
        srcSet: `${image38_480} 480w, ${image38_960} 960w, ${image38_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-23-cocktail-rouge": {
        name: "galerie-23-cocktail-rouge",
        src: image39_1001,
        srcSet: `${image39_480} 480w, ${image39_960} 960w, ${image39_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-24-cocktail-ananas": {
        name: "galerie-24-cocktail-ananas",
        src: image40_1001,
        srcSet: `${image40_480} 480w, ${image40_960} 960w, ${image40_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-25-cocktail-rose": {
        name: "galerie-25-cocktail-rose",
        src: image41_1001,
        srcSet: `${image41_480} 480w, ${image41_960} 960w, ${image41_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-26-cocktail-flambe": {
        name: "galerie-26-cocktail-flambe",
        src: image42_1001,
        srcSet: `${image42_480} 480w, ${image42_960} 960w, ${image42_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-27-bieres": {
        name: "galerie-27-bieres",
        src: image43_1001,
        srcSet: `${image43_480} 480w, ${image43_960} 960w, ${image43_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-28-pates-burrata": {
        name: "galerie-28-pates-burrata",
        src: image44_1001,
        srcSet: `${image44_480} 480w, ${image44_960} 960w, ${image44_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-29-tartare-frites": {
        name: "galerie-29-tartare-frites",
        src: image45_1001,
        srcSet: `${image45_480} 480w, ${image45_960} 960w, ${image45_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-30-tartine": {
        name: "galerie-30-tartine",
        src: image46_1001,
        srcSet: `${image46_480} 480w, ${image46_960} 960w, ${image46_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-31-tartine-burrata": {
        name: "galerie-31-tartine-burrata",
        src: image47_1500,
        srcSet: `${image47_480} 480w, ${image47_960} 960w, ${image47_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-32-entrecote-frites": {
        name: "galerie-32-entrecote-frites",
        src: image48_1001,
        srcSet: `${image48_480} 480w, ${image48_960} 960w, ${image48_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-33-travers": {
        name: "galerie-33-travers",
        src: image49_1001,
        srcSet: `${image49_480} 480w, ${image49_960} 960w, ${image49_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-34-service-plats": {
        name: "galerie-34-service-plats",
        src: image50_1500,
        srcSet: `${image50_480} 480w, ${image50_960} 960w, ${image50_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-35-ceviche-frites": {
        name: "galerie-35-ceviche-frites",
        src: image51_1001,
        srcSet: `${image51_480} 480w, ${image51_960} 960w, ${image51_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-36-nachos": {
        name: "galerie-36-nachos",
        src: image52_1500,
        srcSet: `${image52_480} 480w, ${image52_960} 960w, ${image52_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-37-empanada": {
        name: "galerie-37-empanada",
        src: image53_1500,
        srcSet: `${image53_480} 480w, ${image53_960} 960w, ${image53_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-38-salade-poulet": {
        name: "galerie-38-salade-poulet",
        src: image54_1001,
        srcSet: `${image54_480} 480w, ${image54_960} 960w, ${image54_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-39-tapas-planche": {
        name: "galerie-39-tapas-planche",
        src: image55_1500,
        srcSet: `${image55_480} 480w, ${image55_960} 960w, ${image55_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-40-salade-nicoise": {
        name: "galerie-40-salade-nicoise",
        src: image56_1001,
        srcSet: `${image56_480} 480w, ${image56_960} 960w, ${image56_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-41-poulpe-assiette": {
        name: "galerie-41-poulpe-assiette",
        src: image57_1001,
        srcSet: `${image57_480} 480w, ${image57_960} 960w, ${image57_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-42-tacos": {
        name: "galerie-42-tacos",
        src: image58_1001,
        srcSet: `${image58_480} 480w, ${image58_960} 960w, ${image58_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-43-entrecote-dressee": {
        name: "galerie-43-entrecote-dressee",
        src: image59_1001,
        srcSet: `${image59_480} 480w, ${image59_960} 960w, ${image59_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-44-poulpe-grille": {
        name: "galerie-44-poulpe-grille",
        src: image60_1001,
        srcSet: `${image60_480} 480w, ${image60_960} 960w, ${image60_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-45-four-a-bois": {
        name: "galerie-45-four-a-bois",
        src: image61_1500,
        srcSet: `${image61_480} 480w, ${image61_960} 960w, ${image61_1500} 1500w`,
        width: 1500,
        height: 887,
    },
    "galerie-46-pizzaiolo": {
        name: "galerie-46-pizzaiolo",
        src: image62_1001,
        srcSet: `${image62_480} 480w, ${image62_960} 960w, ${image62_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-47-pizza-flammes": {
        name: "galerie-47-pizza-flammes",
        src: image63_1500,
        srcSet: `${image63_480} 480w, ${image63_960} 960w, ${image63_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-48-viande-grill": {
        name: "galerie-48-viande-grill",
        src: image64_1001,
        srcSet: `${image64_480} 480w, ${image64_960} 960w, ${image64_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-49-poulpe-grill": {
        name: "galerie-49-poulpe-grill",
        src: image65_1001,
        srcSet: `${image65_480} 480w, ${image65_960} 960w, ${image65_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-50-dessert-fraises": {
        name: "galerie-50-dessert-fraises",
        src: image66_1001,
        srcSet: `${image66_480} 480w, ${image66_960} 960w, ${image66_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-51-fondant": {
        name: "galerie-51-fondant",
        src: image67_1085,
        srcSet: `${image67_480} 480w, ${image67_960} 960w, ${image67_1085} 1085w`,
        width: 1085,
        height: 1500,
    },
    "galerie-52-tiramisu": {
        name: "galerie-52-tiramisu",
        src: image68_1001,
        srcSet: `${image68_480} 480w, ${image68_960} 960w, ${image68_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-53-equipe": {
        name: "galerie-53-equipe",
        src: image69_1500,
        srcSet: `${image69_480} 480w, ${image69_960} 960w, ${image69_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "galerie-54-chef-cuisine": {
        name: "galerie-54-chef-cuisine",
        src: image70_1001,
        srcSet: `${image70_480} 480w, ${image70_960} 960w, ${image70_1001} 1001w`,
        width: 1001,
        height: 1500,
    },
    "galerie-55-chef-portrait": {
        name: "galerie-55-chef-portrait",
        src: image71_1500,
        srcSet: `${image71_480} 480w, ${image71_960} 960w, ${image71_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "infoPractice": {
        name: "infoPractice",
        src: image72_1500,
        srcSet: `${image72_480} 480w, ${image72_960} 960w, ${image72_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
    "presentation": {
        name: "presentation",
        src: image73_1500,
        srcSet: `${image73_480} 480w, ${image73_960} 960w, ${image73_1500} 1500w`,
        width: 1500,
        height: 1001,
    },
} satisfies Record<string, ResponsiveImageAsset>;

export const galleryImages: ResponsiveImageAsset[] = Object.values(imageAssets);
export const diapoImages: ResponsiveImageAsset[] = galleryImages.filter((asset) => asset.name.startsWith('diapo'));
